import React from 'react'
import { Card, Col, Empty, Row, Skeleton, Statistic } from 'antd'
import Styles from './index.module.scss'

interface IProps {
  data: any
  percentage?: boolean
  align?: any
  type?: string
  total?: number
  title?: string
}

const Summary: React.FC<IProps> = ({ data, percentage, align, type = 'default', total, title }) => {
  const length = data?.length || 1
  const baseValue = Math.floor(24 / length)
  const remainder = 24 % length
  const breakpoints = Array.from({ length }, (_, index) => (index < remainder ? baseValue + 1 : baseValue))

  return (
    <React.Fragment>
      {!data && (
        <div className={Styles.skeleton}>
          <Skeleton paragraph={{ rows: 2 }} />
        </div>
      )}
      {data && Object.keys(data).length === 0 && (
        <Card bordered={true} className={Styles.empty}>
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
        </Card>
      )}
      {data && (
        <div
          style={
            type === 'default'
              ? {
                  border: '2px solid #dcdcdc',
                  marginTop: '15px',
                  marginBottom: '15px',
                  borderRadius: '10px',
                }
              : {}
          }
        >
          <Row gutter={16} style={{ marginBottom: '15px', marginTop: '15px' }}>
            <h1 className={Styles.summaryTitle}>{title}</h1>
            {data.map((it: any) => {
              return (
                <Col
                  key={it?.id}
                  lg={{ order: 1, span: breakpoints[it.id - 1] }}
                  md={{ order: 1, span: breakpoints[it.id - 1] }}
                  sm={{ order: 3, span: breakpoints[it.id - 1] }}
                  xs={{ order: 3, span: 12 }}
                >
                  <div style={{ background: it?.cardColor, padding: '20px 15px', borderRadius: '10px', textAlign: align }}>
                    <Statistic
                      suffix={<span style={{ fontSize: '14px' }}>{percentage ? `(${it?.percentage}%)` : it.divider ? `${it.divider}${total ? Number(total) : 0}` : ''}</span>}
                      title={
                        <span className={Styles.title} style={type === 'default' ? {} : { color: it?.color }}>
                          {it?.key}
                        </span>
                      }
                      value={it.prefix ? `${it.prefix} ${it.prefix === '$' ? Number(it?.value).toFixed(2) : it?.value}` : it?.value}
                      valueStyle={type === 'default' ? { fontSize: '14px' } : { color: it?.color, fontSize: '18px' }}
                    />
                  </div>
                </Col>
              )
            })}
          </Row>
        </div>
      )}
    </React.Fragment>
  )
}

export default Summary
